module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ja_okinawa-3ec63679e5012442079a4817e5229655.jpg";